import React from "react";
import SectionItem from "./SectionItem";

const BurgerSectionItem = ({isOpen, burgers, section}) => {

    console.log('burgers',burgers,section);
    return (
        <div key={burgers.id} className={"menu-item" + (isOpen.includes(section.id) ? "_collapsed" : "") + " --burger"}>
            <div className="burger-section">
                {burgers.name}
            </div>
            {burgers.burgers.map(burger => (
                <SectionItem isOpen={isOpen} section={section} item={burger} />
            ))}
        </div>
    )
}

export default BurgerSectionItem;